import { updateJob } from '../State/jobs'

export default (key, field, value) => (dispatch) => {

  const data = { [field]: value }

  dispatch(updateJob({ key, data }))
  
}
